<template>
  <div>
    <vs-row>
      <vs-col>
        <vs-row
          vs-w="12"
          class="p-4 text-sm"
          v-show="
            booking.orderLines &&
            booking.orderLines.length > 0 &&
            !isEditingOrderLines
          "
        >
          <vs-col vs-w="12">
            <vs-row vs-w="12">
              <h2 class="font-bold text-sm mb-1">
                {{ booking.orderLines ? booking.orderLines.length : 0 }}
                preordered items
              </h2>
            </vs-row>
            <vs-row vs-w="12">
              <hr
                class="my-3 w-full"
                style="border: none; border-top: solid 1px #bebebe"
              />
            </vs-row>
            <vs-row
              vs-w="12"
              class="mb-2"
              vs-type="flex"
              vs-justify="space-between"
              v-for="item in booking.orderLines"
              :key="item.itemName"
            >
              <div class="flex justify-between w-full">
                <div>
                  <p>
                    <span>{{ item.quantity }}</span> x {{ item.name }}
                  </p>
                  <p class="text-grey">
                    <small>{{ item.description }}</small>
                  </p>
                </div>
                <p>
                  {{
                    formatPrice(
                      getOrderlineTotalPrice(item),
                      item.unitPrice.currency
                    )
                  }}
                  <feather-icon
                    icon="Edit2Icon"
                    svgClasses="md:h-3 md:w-3  h-6 w-6"
                    class="ml-1 cursor-pointer "
                    @click="item.showEditItemPrice = !item.showEditItemPrice"
                  />
                </p>
              </div>
              <div v-if="item.showEditItemPrice">
                <p>Item price</p>
                <vs-input
                  class="inputx w-full"
                  placeholder="Item price"
                  type="number"
                  @change="item.unitPrice.value = item.unitPriceFormatted * 100"
                  v-model="item.unitPriceFormatted"
                />
              </div>
            </vs-row>
            <vs-row vs-justify="flex-start">
              <vs-button
                v-show="!isEditingOrderLines"
                icon="add"
                class="w-full mb-4"
                type="flat"
                @click="addNewOrderLine()"
                size="small"
                :disabled="disableComponent"
                >Add custom order-line
              </vs-button>
            </vs-row>
            <vs-row vs-w="12" vs-justify="flex-end">
              <p>
                <b>{{ formatPrice(getTotalPrice(), "DKK") }}</b>
              </p>
            </vs-row>
            <vs-row vs-w="12" class="mt-4" vs-justify="space-between">
              Payment Received
              <vs-switch success v-model="paymentReceived">
                <template #off>
                  <i class="bx bx-x"></i>
                </template>
                <template #on>
                  <i class="bx bx-check"></i>
                </template>
              </vs-switch>
            </vs-row>
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" class="px-4">
          <hr
            class="mb-3 mt-1 w-full"
            style="
              border-top: 2px dotted #e3e3e3;
              border-bottom: none;
              border-left: none;
              border-right: none;
            "
          />
        </vs-row>
        <vs-row vs-w="12" class="p-4">
          <vs-button
            v-show="!isEditingOrderLines"
            @click="startEditOrderLines()"
            size="small"
            :disabled="disableComponent"
            >Edit order-lines</vs-button
          >
          <div v-if="isLoadingProducts">
            <span class="flex h-4 w-4 mt-2 ml-2">
              <span
                class="
                  animate-ping
                  absolute
                  inline-flex
                  h-4
                  w-4
                  rounded-full
                  bg-primary
                  opacity-75
                "
              ></span>
              <span
                class="relative inline-flex rounded-full h-4 w-4 bg-primary"
              ></span>
            </span>
          </div>
          <vs-col vs-w="12" v-show="isEditingOrderLines">
            <vs-row
              vs-w="12"
              v-for="(product, index) in products"
              :key="index"
              class="flex justify-between mb-4"
            >
              <div>
                <p>{{ product.name }}</p>
                <p class="text-grey">
                  <small>{{ product.description }}</small>
                </p>
              </div>
              <div class="my-auto">
                <div class="flex">
                  <p class="my-auto mr-2 text-right text-grey">
                    <small
                      >@
                      {{
                        formatPrice(
                          getProductUnitPrice(product),
                          product.unitPrice.currency
                        )
                      }}</small
                    >
                  </p>
                  <vs-button
                    @click="product.quantity = Math.max(product.quantity - 1, 0)"
                    class="p-3"
                    size="small"
                    ><span style="width: 25px; height: 25px">-</span></vs-button
                  >
                  <p class="my-auto mx-2 w-6 text-center">
                    {{ product.quantity }}
                  </p>
                  <vs-button @click="product.quantity++" class="p-3" size="small"
                    >+</vs-button
                  >
                </div>
                <p class="my-auto text-right" v-if="getProductPrice(product) > 0">
                  <small>{{
                    formatPrice(
                      getProductPrice(product),
                      product.unitPrice.currency
                    )
                  }}</small>
                </p>
              </div>
            </vs-row>

            <vs-row vs-w="12" vs-justify="flex-end" v-show="isEditingOrderLines">
              <p class="text-right mb-4">
                <b>{{
                  formatPrice(
                    getProductTotalPrice(),
                    products.length > 0 ? products[0].unitPrice.currency : null
                  )
                }}</b>
              </p>
            </vs-row>

            <vs-row vs-justify="flex-end" v-show="isEditingOrderLines">
              <vs-button
                class="mr-2 mb-4"
                size="small"
                @click="addProducts()"
                :disabled="disableComponent"
                >Ok</vs-button
              >
              <vs-button class="mb-4" size="small" @click="handleCancelClick"
                >Cancel</vs-button
              >
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-prompt style="z-index: 999123" :active.sync="orderLinePopupActive" title="Add order line" accept-text="Add order line" @accept="addOrderLine" v-if="newOrderLineProduct">
      <p class="pb-6">Enter the details the order line to add to this booking</p>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Name</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-input class="inputx w-full" placeholder="Product name" v-model="newOrderLineProduct.name"/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Description</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-input class="inputx w-full" placeholder="Product description" v-model="newOrderLineProduct.description"/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Unit price</span>
        </div>
        <div class="vx-col sm:w-4/5">
          <div class="flex items-center">
            <vs-input-number :min="0" :step="10" v-model="newOrderLinePrice"/>
            <span class="ml-2">{{newOrderLineProduct.unitPrice.currency}}</span>
          </div>
        </div>
      </div>
            <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Quantity</span>
        </div>
        <div class="vx-col sm:w-4/5">
          <div class="flex">
            <vs-input-number :min="1" :step="1" v-model="newOrderLineProduct.quantity"/>
          </div>
        </div>
      </div>

      <!-- <vs-textarea readonly v-model="codePopupText"></vs-textarea> -->
    </vs-prompt>
  </div>
</template>

<script>
import * as _ from "lodash";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import { Booking } from "@/store/modules/marcom/data-model/bookings";

export default {
  components: {},
  props: {
    booking: Object,
    venueSetup: Object,
    disableComponent: Boolean
  },
  model: {
    prop: "booking",
    event: "booking-products-updated",
  },
  data() {
    return {
      products: [],
      isLoadingProducts: false,
      isEditingOrderLines: false,
      orderLinePopupActive: false,

      newOrderLineProduct: null,
    };
  },
  computed: {
    newOrderLinePrice: {
      get() {
        return this.newOrderLineProduct.unitPrice.value / 100;
      },
      set(newValue) {
        this.newOrderLineProduct.unitPrice.value = newValue * 100;
      }
    },
    paymentReceived: {
      get: function () {
        return !!this.booking && !!this.booking.paymentReceived;
      },
      set: function (newValue) {
        this.booking.paymentReceived = newValue;
        this.$emit(
          "booking-products-updated",
          Object.assign(new Booking(), this.booking)
        );
      },
    },
  },
  methods: {
    getOrderlineTotalPrice(orderLine) {
      const intAmount = orderLine.quantity * orderLine.unitPrice.value;
      const decAmount = intAmount / 100;
      return decAmount;
    },
    formatPrice(decAmount, currency) {
      var options = {};
      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
      if (currency)
        _.assign(options, { style: "currency", currency: currency });
      var formatter = new Intl.NumberFormat("en-US", options);

      return formatter.format(decAmount); /* $2,500.00 */
    },
    getTotalPrice() {
      var tot = 0;
      if (this.booking && this.booking.orderLines) {
        for (const orderLine of this.booking.orderLines) {
          tot += this.getOrderlineTotalPrice(orderLine);
        }
      }
      return tot;
    },
    getProductUnitPrice(product) {
      const intAmount = product.unitPrice.value;
      const decAmount = intAmount / 100;
      return decAmount;
    },
    getProductPrice(product) {
      const intAmount = product.quantity * product.unitPrice.value;
      const decAmount = intAmount / 100;
      return decAmount;
    },
    getProductTotalPrice() {
      var tot = 0;
      if (this.products) {
        for (const product of this.products) {
          tot += this.getProductPrice(product);
        }
      }
      return tot;
    },
    addNewOrderLine() {
      this.newOrderLineProduct = {
        name: "Custom product",
        category: "Custom order line",
        description: "",
        quantity: 1,
        unitPrice: {
          value: 50000,
          currency: "DKK",
        },
      };
      this.orderLinePopupActive = true;
    },
    addOrderLine() {
      this.booking.orderLines.push(this.newOrderLineProduct);
      this.newOrderLineProduct = null;
    },
    async startEditOrderLines() {
      if (!this.venueSetup) {
        this.$vs.notify({
          color: "danger",
          title: "No setup selected",
          text: "You need to select a setup to add products",
        });
        return;
      }
      this.isLoadingProducts = true;

      try {
        this.products = await this.$store.dispatch(
          "marcom/" + VENUE_ACTIONS.GetProductsBySetup,
          this.venueSetup
        );
        for (const product of this.products) {
          this.$set(product, "quantity", 0);
       
          var order = this.booking.orderLines.find((order) => order.name == product.name)
          if(order){
            this.$set(product, "quantity", order.quantity);
          }
        }

        // Add the custom order lines to the products as they are not part of the venue setup
        const customOrderLines = this.booking.orderLines.filter(e => e.category == "Custom order line");
        this.products = [...this.products, ...customOrderLines];

        this.isEditingOrderLines = true;
        this.$emit("editing-order-lines-changed", this.isEditingOrderLines);
      } catch (err) {
        console.error(err);
        this.$vs.notify({
          color: "danger",
          title: "Error getting products",
          text: "Getting products for the active setup failed.",
        });
      } finally {
        this.isLoadingProducts = false;
      }
    },
    addProducts() {
      this.booking.orderLines = this.products
        .filter((p) => p.quantity > 0)
        .map((p) => {
          return {
            name: p.name,
            quantity: p.quantity,
            unitPrice: p.unitPrice,
            description: p.description,
            category: p.category,
          };
        });

      this.products = [];
      this.isEditingOrderLines = false;
      this.$emit("editing-order-lines-changed", this.isEditingOrderLines);
      this.$emit(
        "booking-products-updated",
        Object.assign(new Booking(), this.booking)
      );
    },
    handleCancelClick() {
      this.products = [];
      this.isEditingOrderLines = false;
      this.$emit("editing-order-lines-changed", this.isEditingOrderLines);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
